import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();

  // If the user is not authenticated, store the current location in sessionStorage and redirect to login
  if (!isAuthenticated) {
    // Store the current pathname in sessionStorage
    sessionStorage.setItem('redirectPath', location.pathname);
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
